import { render, staticRenderFns } from "./BlockOverlay.vue?vue&type=template&id=babc227c&scoped=true"
import script from "./BlockOverlay.vue?vue&type=script&lang=js"
export * from "./BlockOverlay.vue?vue&type=script&lang=js"
import style0 from "./BlockOverlay.vue?vue&type=style&index=0&id=babc227c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babc227c",
  null
  
)

export default component.exports